<template>
  <section class="section-base top-section">
    <v-container>
      <v-row class='fill-height'>
        <v-col cols="pl-0" xl='7' lg='7' md='7' sm='12' xs='12'>
          <WelcomeCard style='height: 100%'/>
        </v-col>
        <v-col cols="pr-0" xl='5' lg='5' md='5' sm='12' xs='12'>
          <Slider/>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import WelcomeCard from "@/components/elements/other/TopCard";
import Slider from "@/components/elements/other/Slider";


export default {
  name: "Top",
  components: { WelcomeCard, Slider }
}
</script>

<style scoped>

</style>
